import { MdCreditCard } from "react-icons/md";
import { AmexIcon, JcbIcon, MasterCardIcon, VisaIcon } from "./Icons";

export default function CardBrandIcon({
  brand,
  className,
  size,
}: {
  brand: string | undefined;
  className?: string;
  size?: number;
}) {
  switch (brand) {
    case "visa":
      return <VisaIcon size={size || 37} className={className || ""} />;
    case "mastercard":
      return <MasterCardIcon size={size || 28} className={className || ""} />;
    case "amex":
      return <AmexIcon size={size || 20} className={className || ""} />;
    case "jcb":
      return <JcbIcon size={size || 24} className={className || ""} />;
    default:
      return <MdCreditCard size={size || 24} className={className || ""} />;
  }
}
